import { Box, Typography } from '@mui/material';

import { StatusIndicatorColors } from './status-indicator.types';
import { getIndicatorColor } from './status-indicator.utils';

export type StatusIndicatorProps = {
  color?: StatusIndicatorColors;
  label?: string;
};

export const StatusIndicator = ({ color = 'gray', label }: StatusIndicatorProps) => (
  <Box display='flex' alignItems='center' gap={1}>
    <Box
      sx={{
        width: 8,
        height: 8,
        borderRadius: '50%',
        bgcolor: getIndicatorColor(color),
      }}
    />
    {label && <Typography variant='body2'>{label}</Typography>}
  </Box>
);
